import React from 'react';
import cn from 'classnames';
import { DH } from '../../utils/DataHook';
import { t } from '../../utils/i18n';
import * as s from './TermsAndSubmit.scss';
import { keyCodes, isEventKey } from '../../utils/key-codes';
import { useAdaptedComponents } from '../../hooks/useAdaptedComponents';

interface ITermsAndSubmitProps {
  showError?: boolean;
  checked: boolean;
  termsAndConditionsLink?: string;

  handleTermsStatusChange?(e: any): void;
}

export const TermsAndSubmit: React.FunctionComponent<ITermsAndSubmitProps> = (
  props
) => {
  const ariaLabel = `${t('terms.conditions.agree')} ${t('terms.conditions')}`;

  const onInputKeyDown = (e) => {
    if (isEventKey(e, keyCodes.enter)) {
      e.target.click();
    }
  };

  const onLinkKeyDown = (e) => {
    if (isEventKey(e, keyCodes.space)) {
      e.target.click();
    }
  };

  const AdaptedComponents = useAdaptedComponents();

  if (AdaptedComponents) {
    return (
      <div className={s.adaptedTerms}>
        <AdaptedComponents.Checkbox
          onChange={props.handleTermsStatusChange}
          checked={props.checked}
          error={props.showError}
          errorMessage={t('terms.conditions.error')}
        >
          <span aria-hidden="true">{t('terms.conditions.agree')}</span>{' '}
          <AdaptedComponents.TextButton
            href={props.termsAndConditionsLink}
            ariaLabel={ariaLabel}
            disabled={!props.termsAndConditionsLink}
          >
            <span>{t('terms.conditions')}</span>
          </AdaptedComponents.TextButton>
        </AdaptedComponents.Checkbox>
      </div>
    );
  }

  return (
    <div data-hook={DH.TermsAndSubmit.Container} className={s.terms}>
      <section>
        <input
          id="accept-terms"
          type="checkbox"
          aria-checked={props.checked}
          data-hook={DH.TermsAndSubmit.Checkbox}
          onChange={props.handleTermsStatusChange}
          checked={props.checked}
          aria-label={ariaLabel}
          aria-describedby="payment-terms-error"
          tabIndex={0}
          onKeyDown={onInputKeyDown}
        />
        <label
          htmlFor="accept-terms"
          className={cn(props.showError && s.errorInput)}
          aria-label={ariaLabel}
          aria-checked={props.checked}
          role="checkbox"
        >
          <span aria-hidden="true">{t('terms.conditions.agree')}</span>
        </label>
        <a
          tabIndex={0}
          className={cn(
            s.termsLink,
            !props.termsAndConditionsLink && s.disabledLink
          )}
          href={props.termsAndConditionsLink}
          target="_blank"
          onKeyDown={onLinkKeyDown}
          aria-label={ariaLabel}
        >
          <span>{t('terms.conditions')}</span>
        </a>
      </section>
      {props.showError && (
        <div
          className={s.errorLabel}
          id="payment-terms-error"
          data-hook={DH.TermsAndSubmit.Error}
        >
          {t('terms.conditions.error')}
        </div>
      )}
    </div>
  );
};
TermsAndSubmit.displayName = 'TermsAndSubmit';
